import React, { Component } from 'react';
import { JssProvider } from 'react-jss';
import { hot } from 'react-hot-loader';
import { compose } from 'recompose';
import ClientProvider from '../../application/client/ClientProvider';
import ContactForm from './ContactForm';
import withApplicationProvider from '../../application/hoc/withApplicationProvider';

import withGlobalize from '../../application/globalize/withGlobalize';
import withApplication from '../../application/hoc/withApplication';

type Props = {
  isWhite: boolean,
  host: string,
};

class ContactFormApp extends Component<Props> {
  render() {
    const { generateClassName, isWhite, host } = this.props;
    return (
      <JssProvider generateClassName={generateClassName}>
        <ClientProvider host={host}>
          <ContactForm isWhite={isWhite} {...this.props} />
        </ClientProvider>
      </JssProvider>
    );
  }
}

const ContactFormAppComposed = compose(
  withApplicationProvider(),
  withApplication(),
  withGlobalize(),
)(ContactFormApp);

export default hot(module)(ContactFormAppComposed);

// export default function SuitcaseAppOuter(props: Props) {
//   return <SuitcaseAppComposed {...props} />;
// };



// WEBPACK FOOTER //
// ./src/components/ContactForm/ContactFormApp.js